import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Box, Typography, Button } from '@mui/material';
import SecurityIcon from '@mui/icons-material/Security';
import PublicIcon from '@mui/icons-material/Public';
import TuneIcon from '@mui/icons-material/Tune';
import FlashOnIcon from '@mui/icons-material/FlashOn';


const FeatureItem = ({ icon, title, description }) => (
  <Box display="flex" alignItems="flex-start" mb={2}>
    <Box
      sx={{
        bgcolor: 'rgba(255,255,255,0.1)',
        color: '#fff',
        p: 1,
        borderRadius: 1,
        mr: 2,
        mt: 0.5,
      }}
    >
      {icon}
    </Box>
    <Box>
      <Typography variant="body2" fontWeight="bold" color="#fff">
        {title}
      </Typography>
      <Typography variant="caption" color="#cbd5e1">
        {description}
      </Typography>
    </Box>
  </Box>
);

const CardFeaturesWidget = () => (
  <Box 
    mt={3}
    mb={8}
    p={3}
    borderRadius={3}
    sx={{
      mr: 2,
      background: 'linear-gradient(135deg, #1d4ed8, #2563eb)',
    }}
  >
    <Typography
      variant="body1"
      color="#fff" 
      textAlign="left" 
      whiteSpace={'pre-line'}
      fontSize="0.80rem"
      fontWeight={40}
      mb={2}
      sx={{ lineHeight: 1.5 }}
    >
      Create virtual cards for online payments, subscriptions, and more. Our
      virtual cards provide enhanced security and control over your spending.
    </Typography>

    <FeatureItem
      icon={<SecurityIcon fontSize="small" />}
      title="Secure Payments"
      description="Protect your online transactions with virtual cards"
    />
    <FeatureItem
      icon={<PublicIcon fontSize="small" />}
      title="Global Acceptance"
      description="Use anywhere major cards are accepted online"
    />
    <FeatureItem
      icon={<TuneIcon fontSize="small" />}
      title="Spending Controls"
      description="Set limits and monitor transactions in real-time"
    />
    <FeatureItem
      icon={<FlashOnIcon fontSize="small" />}
      title="Instant Issuance"
      description="Create and use cards within minutes"
    />

    <Button
      component={RouterLink}
      to="/card-application"
      variant="contained"
      color="primary"
      sx={{
        mt: 2,
        bgcolor: '#fff',
        color: '#1d4ed8',
        fontWeight: 'bold',
        borderRadius: 2,
        textTransform: 'none',
        '&:hover': {
          bgcolor: '#e0e7ff',
        },
      }}
    >
      Apply Now
    </Button>
  </Box>
);  

export default CardFeaturesWidget;